
export const HeadText = (props)=> {

    return (
        <div>
            <h1 className="flex justify-center items-center  text-2xl lg:text-4xl  font-medium my-5 text-white p-4 bg-black rounded-xl w-auto" >{props.text}</h1>
        </div>
    )
}